const TARGET_SELECTOR = [
  'main[data-template^="product"] .fp-house-salon__image',
  'main[data-template^="product"] .fp-merch-card__image',
  'main[data-template^="collection"] .card-gallery img',
  'main[data-template^="search"] .card-gallery img',
].join(',');

const DEFAULT_CANVAS = '#ffffff';
const sampledColors = new Map();

function averageEdgeColor(image) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d', { willReadFrequently: true });
  if (!context || !image.naturalWidth || !image.naturalHeight) return null;

  canvas.width = 24;
  canvas.height = 24;
  context.drawImage(image, 0, 0, canvas.width, canvas.height);

  const points = [];
  for (let index = 0; index < canvas.width; index += 2) {
    points.push([index, 0], [index, canvas.height - 1]);
  }
  for (let index = 2; index < canvas.height - 2; index += 2) {
    points.push([0, index], [canvas.width - 1, index]);
  }

  let red = 0;
  let green = 0;
  let blue = 0;
  let count = 0;
  for (const [x, y] of points) {
    const pixel = context.getImageData(x, y, 1, 1).data;
    if (pixel[3] < 230) continue;
    red += pixel[0];
    green += pixel[1];
    blue += pixel[2];
    count += 1;
  }

  if (!count) return null;
  const channels = [red, green, blue].map((value) => Math.round(value / count));
  const spread = Math.max(...channels) - Math.min(...channels);
  const brightness = channels.reduce((sum, value) => sum + value, 0) / 3;

  // Only extend neutral, light studio fields. Colorful/editorial scenes keep house white.
  if (brightness < 205 || spread > 18) return null;
  return `rgb(${channels.join(' ')})`;
}

async function sampledEdgeColor(source) {
  if (!source) return null;
  if (!sampledColors.has(source)) {
    sampledColors.set(source, new Promise((resolve) => {
      const sample = new Image();
      sample.crossOrigin = 'anonymous';
      sample.onload = () => {
        try { resolve(averageEdgeColor(sample)); }
        catch (_error) { resolve(null); }
      };
      sample.onerror = () => resolve(null);
      sample.src = source;
    }));
  }
  return sampledColors.get(source);
}

function applyCanvas(image) {
  if (!(image instanceof HTMLImageElement) || image.dataset.fpCanvasReady === 'true') return;
  const finish = async () => {
    try {
      const color = await sampledEdgeColor(image.currentSrc || image.src) || DEFAULT_CANVAS;
      const media = image.closest('.fp-house-salon__media-item, .fp-merch-card__media, .card-gallery');
      media?.style.setProperty('--fp-photo-canvas', color);
      image.dataset.fpCanvasReady = 'true';
    } catch (_error) {
      image.dataset.fpCanvasReady = 'true';
    }
  };
  if (image.complete) finish();
  else image.addEventListener('load', finish, { once: true });
}

function scan(root = document) {
  root.querySelectorAll?.(TARGET_SELECTOR).forEach(applyCanvas);
}

scan();
const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches?.(TARGET_SELECTOR)) applyCanvas(node);
      scan(node);
    }
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
